/**
 * Default Bundle — Custom Element Registration (Issue #94)
 *
 * The default bundle underlies every page that does not load a more
 * specific shell — most importantly the auth pages (login, register,
 * password reset, 2FA), about, and any page that just extends base.html.
 *
 * Those templates render `<svg-icon>` and `<copy-right>` directly. Before
 * Pattern A those tags self-registered via module-bottom side-effects in
 * the components/ files. After Pattern A the default shell must call
 * `registerSharedElements()` explicitly — that's the job of this file.
 *
 * The default shell has no data layer; registration runs at the start of
 * `_initModule()`, before auth completes.
 */

import { registerSharedElements } from '../components/register-shared-elements.js';

const DEFAULT_ELEMENTS = [
  // Default-bundle-specific custom elements go here. Empty today.
];

export function registerDefaultElements() {
  registerSharedElements();
  for (const [tag, klass] of DEFAULT_ELEMENTS) {
    if (!customElements.get(tag)) {
      customElements.define(tag, klass);
    }
  }
}
